import React from 'react'
import PropTypes from 'prop-types'
import { Grid, CircularProgress } from '@mui/material'
import ReactPlayer from 'react-player'
import clsx from 'clsx'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import { withStyles } from '~/themes/useStyles'
import Checkbox from '~/components/common/Checkbox'
import { isFileImage } from '~/utils/helpers/media'
import style from './style'

const GridView = ({
  classes,
  files,
  selectVideo,
  selectImage,
  fileSelected,
  loading,
  mediaFile,
  isFileSelected,
  handleSelectFile,
  handleOpenFile,
  bulkSelect,
  galleryMode,
}) => {
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down(1165))

  const renderVideo = (file, index) => (
    <div
      className={classes.videoContainer}
      onClick={() => selectVideo && handleSelectFile(file, index)}
      onDoubleClick={() => handleOpenFile(index)}
      role="presentation"
    >
      <img
        className={classes.videoImage}
        alt="play-video"
        src="/img/play-video.svg"
      />
      <ReactPlayer
        className={classes.video}
        url={file.src}
        light={file.thumbnail}
        playing={false}
        width="100%"
        height="100%"
      />
      {fileSelected && bulkSelect && (
        <div className={classes.selectedButtonContainer}>
          <Checkbox
            className={classes.selectedButton}
            onClick={() => selectVideo && handleSelectFile(file, index)}
            checked={isFileSelected(file)}
            disabled={!selectVideo}
            classes={{
              checkedIcon: classes.checkedIcon,
              uncheckedIcon: classes.uncheckedIcon,
            }}
          />
        </div>
      )}
    </div>
  )

  const renderImage = (file, index) => (
    <div
      className={classes.imageContainer}
      role="presentation"
      onClick={() => selectImage && handleSelectFile(file, index)}
      onDoubleClick={() => handleOpenFile(index)}
    >
      <img
        src={file.thumbnail || file.src}
        alt={file.name}
        className={classes.image}
      />
      {fileSelected && bulkSelect && (
        <div className={classes.selectedButtonContainer}>
          <Checkbox
            className={classes.selectedButton}
            disabled={!selectImage}
            checked={isFileSelected(file)}
            onClick={() => selectImage && handleSelectFile(file, index)}
            classes={{
              checkedIcon: classes.checkedIcon,
              uncheckedIcon: classes.uncheckedIcon,
            }}
          />
        </div>
      )}
    </div>
  )

  const renderFiles = () =>
    files.map((file, index) => (
      <Grid
        key={file.id}
        data-name={
          file.title || file.name.replace(/.jpg|.png|.jpeg|.mp4|.quicktime/, '')
        }
        data-id={file.id}
        item
        md={3}
        sm={3}
        lg={1}
        xl={1}
      >
        <div
          draggable="true"
          className={clsx(
            classes.fileContainer,
            isFileSelected(file) &&
              ((isTablet && bulkSelect) || galleryMode) &&
              'selected',
            'mediaFile',
          )}
        >
          <div
            className={clsx({ [classes.bgFile]: !isTablet }, 'bg-image')}
            onDoubleClick={() => handleOpenFile(index)}
          />
          {isFileImage(file)
            ? renderImage(file, index)
            : renderVideo(file, index)}
        </div>
      </Grid>
    ))

  return (
    <Grid
      id="mediaFileContainer"
      container
      className={classes.gridContainer}
      spacing={2}
    >
      {renderFiles()}
      {loading.getListFile &&
      mediaFile.total_pages &&
      mediaFile.page <= mediaFile.total_pages ? (
        <div className={classes.containerLoadMore}>
          <CircularProgress size={14} />
        </div>
      ) : (
        ''
      )}
    </Grid>
  )
}

GridView.defaultProps = {
  fileSelected: null,
  bulkSelect: false,
}

GridView.propTypes = {
  classes: PropTypes.shape().isRequired,
  loading: PropTypes.oneOfType([PropTypes.object, PropTypes.shape()])
    .isRequired,
  files: PropTypes.oneOfType([PropTypes.array, PropTypes.shape()]).isRequired,
  mediaFile: PropTypes.oneOfType([PropTypes.object, PropTypes.shape()])
    .isRequired,
  fileSelected: PropTypes.oneOfType([PropTypes.array, PropTypes.shape()]),
  isFileSelected: PropTypes.oneOfType([PropTypes.func, PropTypes.shape()])
    .isRequired,

  selectVideo: PropTypes.bool.isRequired,
  selectImage: PropTypes.bool.isRequired,
  handleSelectFile: PropTypes.func.isRequired,
  handleOpenFile: PropTypes.func.isRequired,
  bulkSelect: PropTypes.bool,
  galleryMode: PropTypes.bool.isRequired,
}

export default withStyles(style)(GridView)
